import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SEVERITY } from '../../utils/Snackbar';
import { put } from '../../utils/Api';
import { useParams } from "react-router";
import { useNavigate } from "react-router";

import LockIcon from '@mui/icons-material/Lock';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import StaticHeader from '../../utils/StaticHeader';

export default function SenhasDialog(props) {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [senhas, setSenhas] = useState({
    usuario_senha: '',
    usuario_senha_confirmar: '',
  });

  const [aviso,setAviso] = useState('alerta');
  const [avisoConfirmar,setAvisoConfirmar] = useState('alerta');

  const validarTamanhoSenha = (senha) => {
    return (senha.length < 5) ? 'alerta' : 'revisado';
  };

  const validarSenhaConfirmar = (senha,confirmar) => {
    if (confirmar.length === 0) {
      return 'alerta';
    } else if (confirmar !== senha) {
      return 'incompleto';
    } else {
      return 'revisado';
    }
  };

  const handleChange = (event) => {
    const {name, value} = event.target;

    if (name === 'usuario_senha') {
      setAviso(validarTamanhoSenha(value));
      setAvisoConfirmar(validarSenhaConfirmar(value,senhas.usuario_senha_confirmar));
    }

    if (name === 'usuario_senha_confirmar') {
      setAvisoConfirmar(validarSenhaConfirmar(senhas.usuario_senha,value));
    }

    setSenhas((dados) => ({
      ...dados,
      [name]: value
    }));
  };

  const handleSalvar = () => {
    if (props.error) { return; }

    /* Validações */
    if (aviso !== 'revisado') {
      props.handleMessage(
        'Senha menor que 5 caracteres!',
        SEVERITY.WARNING.toString(),
        '',
        false
      );
      return;
    }

    if (avisoConfirmar !== 'revisado') {
      props.handleMessage(
        'As senhas digitadas estão diferentes!',
        SEVERITY.WARNING.toString(),
        '',
        false
      );
      return;
    }
    /* Validações */

    /* Enviar */
    props.setLoading(true);
    put(`/api/usuario/${uuid}/senhas`,senhas,(json)=>{

      props.setLoading(false);
      if (json.senhas_alteradas) {
        props.handleMessage('Senhas alteradas com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
      } else {
        props.handleMessage('Falha ao alterar as senhas!',SEVERITY.WARNING.toString(),'',false);
      }

      navigate('/');

    },(error,message,severity)=>{
      props.setLoading(false);
      props.handleMessage(message,severity,error,true);
    });
    /* Enviar */
  };

  const exibirIcon = (variavel) => {
    return (variavel !== 'revisado') ? (
      <ErrorIcon
        fontSize="large"
        color={variavel}
        sx={{
          marginTop: '10px'
        }}/>
    ) : (
      <CheckCircleIcon
        fontSize="large"
        color={variavel}
        sx={{
          marginTop: '10px'
        }}
      />
    )
  };

  return (
    <StaticHeader
      version={props.version}
      setLoading={props.setLoading}
      handleMessage={props.handleMessage}
      error={props.error}
      setError={props.setError}>
      <Dialog
        closeAfterTransition={false}
        open={true}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          handleSalvar(event);
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
            <LockIcon sx={{ display: 'flex' }} />
            <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
              Redefinir Senha
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{ width: { xs: 'auto', sm: 400 } }}>

          <Grid
            container
            sx={{
              marginTop: 4,
            }}>

            <Grid item="true" size={10.5} sx={{ marginBottom: '24px' }}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_senha"
                name="usuario_senha"
                label="Senha"
                value={senhas.usuario_senha}
                onChange={handleChange}
                type="password"
              />
            </Grid>

            <Grid item="true" size={1.5} sx={{ textAlign: 'right' }}>
              {exibirIcon(aviso)}
            </Grid>

            <Grid item="true" size={10.5}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_senha_confirmar"
                name="usuario_senha_confirmar"
                label="Confirmar Senha"
                value={senhas.usuario_senha_confirmar}
                onChange={handleChange}
                type="password"
              />
            </Grid>

            <Grid item="true" size={1.5} sx={{ textAlign: 'right' }}>
              {exibirIcon(avisoConfirmar)}
            </Grid>

          </Grid>

        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={()=>{
              navigate(`/`);
            }}>
            Voltar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<CheckCircleIcon />}>
            Salvar Senha
          </Button>
        </DialogActions>
      </Dialog>
    </StaticHeader>
  );
}
